module.exports = __webpack_public_path__ + "static/media/BG_2.eafd0bda.png";